
        var result = require("!!../../../../../node_modules/css-loader/index.js!./coal-statistics.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/coal/coal-statistics/coal-statistics.component.css
// module id = 772
// module chunks = 0